const youtubeKey = "AIzaSyCAY1GNH5AYSiDptYbAcj3QML5Q3LBIcug";
export default youtubeKey;